import crudActions from '@/store/crudActions'

const endpoint = 'additional-exam-check'
const Actions = crudActions(endpoint)

export default {
  ...Actions,
}
